module.exports = __webpack_public_path__ + "abe125f4d933685adaeb07733d567855.png";